/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChargeActiveList } from '../../models/charge-active-list';

export interface GetStationActiveCharges$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;
}

export function getStationActiveCharges(http: HttpClient, rootUrl: string, params: GetStationActiveCharges$Params, context?: HttpContext): Observable<StrictHttpResponse<ChargeActiveList>> {
  const rb = new RequestBuilder(rootUrl, getStationActiveCharges.PATH, 'get');
  if (params) {
    rb.path('uid', params.uid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChargeActiveList>;
    })
  );
}

getStationActiveCharges.PATH = '/stations/{uid}/charges/active';
